import { useAssessments } from '../../../hooks/AssessmentsContext'

import { Filter as FilterUI } from '../../../components/ui/Filter'
import { CAMPO } from '../../../components/ui/Filter/sizes'
import { Select } from '../../../components/ui/Form/Select'

/**
 * Mesmo desenho de filtro das demais telas. O periodo aplica na hora, como
 * sempre aplicou, entao nao existe botao Filtrar aqui — e por isso tambem nao
 * existe Limpar: botao que nao submete nada so ocuparia espaco.
 */
export function Filter() {
  const { getFilter, updateFilter } = useAssessments()
  const { period } = getFilter()

  return (
    <FilterUI.Root onSubmit={(evento) => evento?.preventDefault?.()}>
      <FilterUI.Container>
        <Select.Root
          label="Período"
          style={CAMPO.grande}
          value={period}
          onChange={(valor) => updateFilter({ period: valor })}
        >
          <Select.Option value="all-period">Todo o período</Select.Option>
          <Select.Option value="last-90-days">Últimos 90 dias</Select.Option>
          <Select.Option value="last-30-days">Últimos 30 dias</Select.Option>
          <Select.Option value="last-7-days">Últimos 7 dias</Select.Option>
        </Select.Root>
      </FilterUI.Container>
    </FilterUI.Root>
  )
}
